module.exports = __webpack_public_path__ + "static/acrylic02-6d547bb0d44d6de5dba8c619f70f4185.jpg";